export const Units = {
  auto: 'auto',
  none: 0,
  xxs: 4,
  xs: 8,
  small: 16,
  medium: 24,
  large: 40,
  xl: 60,
  xxl: 80
};

export const getSpacing = paddingUnit => {
  if (typeof paddingUnit === 'string' && paddingUnit in Units) {
    return `${Units[paddingUnit]}px`;
  }

  if (typeof paddingUnit === 'number') {
    return `${paddingUnit}px`;
  }

  const SpacingConfig = paddingUnit;

  if (SpacingConfig.horizontal) {
    if (typeof SpacingConfig.horizontal === 'number') {
      return `0 ${SpacingConfig.horizontal}px`;
    }

    let horizontalUnit = Units.medium;

    if (SpacingConfig.horizontal in Units) {
      horizontalUnit = Units[SpacingConfig.horizontal];
    }

    if (horizontalUnit === Units.auto) {
      return `${horizontalUnit} 0`;
    }

    return `0 ${horizontalUnit}px`;
  }

  if (SpacingConfig.vertical) {
    if (typeof SpacingConfig.vertical === 'number') {
      return `${SpacingConfig.vertical}px 0`;
    }

    let verticalUnit = Units.medium;

    if (SpacingConfig.vertical in Units) {
      verticalUnit = Units[SpacingConfig.vertical];
    }

    if (verticalUnit === Units.auto) {
      return `${verticalUnit} 0`;
    }

    return `${verticalUnit}px 0`;
  }

  const spacing = {
    bottom: SpacingConfig.bottom || 0,
    left: SpacingConfig.left || 0,
    right: SpacingConfig.right || 0,
    top: SpacingConfig.top || 0
  };

  const top = typeof spacing.top === 'number' ? spacing.top : Units[spacing.top];
  const bottom = typeof spacing.bottom === 'number' ? spacing.bottom : Units[spacing.bottom];
  const left = typeof spacing.left === 'number' ? spacing.left : Units[spacing.left];
  const right = typeof spacing.right === 'number' ? spacing.right : Units[spacing.right];

  return `${top}px ${right}px ${bottom}px ${left}px`.replace(/autopx/g, 'auto');
};
